import React from 'react'
const ErrorPage = () => {
  return <div className="Post">this is the error page</div>
}
export default ErrorPage
